/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./dx-head-dropdown-panel.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./dx-head-dropdown-panel.component";
var styles_DxHeadDropdownPanelComponent = [i0.styles];
var RenderType_DxHeadDropdownPanelComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DxHeadDropdownPanelComponent, data: {} });
export { RenderType_DxHeadDropdownPanelComponent as RenderType_DxHeadDropdownPanelComponent };
export function View_DxHeadDropdownPanelComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_DxHeadDropdownPanelComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dx-head-dropdown-panel", [], null, null, null, View_DxHeadDropdownPanelComponent_0, RenderType_DxHeadDropdownPanelComponent)), i1.ɵdid(1, 245760, null, 0, i2.DxHeadDropdownPanelComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DxHeadDropdownPanelComponentNgFactory = i1.ɵccf("dx-head-dropdown-panel", i2.DxHeadDropdownPanelComponent, View_DxHeadDropdownPanelComponent_Host_0, { menuNode: "menuNode" }, {}, []);
export { DxHeadDropdownPanelComponentNgFactory as DxHeadDropdownPanelComponentNgFactory };
